module.exports = __webpack_public_path__ + "static/media/21ECLAC46.18fd3cb9.jpg";